import * as React from 'react';
import { Spin } from 'components/antd';
import AntInput, { InputProps } from 'antd/lib/input/Input';
import AntInputGroup, { GroupProps } from 'antd/lib/input/Group';
import AntInputSearch, { SearchProps } from 'antd/lib/input/Search';
import classNames from 'classnames';
import { ThemeContext } from 'app-themes';

import styles from './Input.module.scss';
import Password from 'antd/lib/input/Password';

const InputGroup: React.SFC<GroupProps> = props => {
	return <AntInputGroup {...props}>{props.children}</AntInputGroup>;
};

const Search: React.SFC<SearchProps> = props => {
	return <AntInputSearch {...props}>{props.children}</AntInputSearch>;
};
interface Props extends InputProps {
	isLoading?: boolean;
	maxLength?: number;
	isFocused?: boolean;
	onFocusWithoutEvent?: () => void;
}
interface State {
	isEditing: boolean;
	value?: string;
	isFocused?: boolean;
}
export class Input extends React.Component<Props, State> {
	static Group: typeof InputGroup;
	static Search: typeof Search;
	static Password: typeof Password;
	static contextType = ThemeContext;

	inputRef = React.createRef<AntInput>();

	state = {
		isEditing: false,
		value: undefined,
		isFocused: false,
	};

	focus = () => {
		const { current } = this.inputRef;
		if (current) {
			current.focus();
		}
		if (this.props.onFocusWithoutEvent) {
			this.props.onFocusWithoutEvent();
		}
		this.setState({ isFocused: true });
	};

	blur = () => {
		const { current } = this.inputRef;
		if (current) {
			current.blur();
		}
		this.setState({ isFocused: false });
	};

	focusHandler = (e: React.FocusEvent<HTMLInputElement>) => {
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
		this.setState({ isEditing: true });
	};

	blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
		this.setState({ isEditing: false });
	};

	componentDidUpdate(_prevProps: Readonly<Props>, _prevState: Readonly<State>): void {
		if (this.props.isFocused && !this.state.isFocused) {
			// for now it is needed only for FlightAddressInput component
			// due to problems with focus() on removing prefix (see ant documentation)
			this.focus();
		}
		if (this.props.isFocused === false && this.state.isFocused) {
			// handle only case when isFocused is defined
			this.blur();
		}
	}

	render() {
		const {
			className,
			isLoading,
			disabled,
			isFocused,
			onFocusWithoutEvent,
			...restProps
		} = this.props;
		const theme = this.context;
		return (
			<Spin spinning={Boolean(isLoading)} className={styles.spin}>
				<AntInput
					className={classNames(styles.input, className, {
						[styles[`input-${theme}`]]: theme !== '',
					})}
					ref={this.inputRef}
					{...restProps}
					disabled={disabled || isLoading}
					onFocus={this.focusHandler}
					onBlur={this.blurHandler}
				/>
			</Spin>
		);
	}
}

Input.Group = InputGroup;
Input.Search = Search;
Input.Password = Password;

export default Input;
